import React from 'react';

import { Button, Box, Typography, SxProps, Theme } from '@mui/material';

import { NoteStatusFilterOption } from '../../constants/FilterOptions';
import MenuOption from '../../types/MenuOption';
import ResultsFilterCheckboxMenu from '../CheckboxMenu/ResultsFilterCheckboxMenu';

import './MenuButton.scss';

type Props = {
  handleSelection: (
    option: MenuOption<NoteStatusFilterOption>,
    checked: boolean
  ) => void;
  options: MenuOption<NoteStatusFilterOption>[];
  title: string;
  sx?: SxProps<Theme>;
};

const UserFilterMenuButton: React.FC<Props> = ({
  options,
  handleSelection,
  title,
  sx,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const count = options.filter((option) => option.selected).length;
  const open = Boolean(anchorEl);
  const highlighted = open || count > 0;
  const id = open ? 'simple-popover' : undefined;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={sx}>
      <Button
        sx={{
          borderRadius: '8px',
        }}
        disableElevation
        variant={'contained'}
        color={highlighted ? 'primaryLight' : 'defaultWhite'}
        onClick={handleClick}
      >
        {count !== 0 && (
          <Box className='count-label'>
            <Typography color='white' variant='caption'>
              {count}
            </Typography>
          </Box>
        )}
        <Typography color={highlighted ? 'text.primary' : 'text.secondary'}>
          {title}
        </Typography>
      </Button>
      <ResultsFilterCheckboxMenu
        handleSelection={handleSelection}
        options={options}
        anchorEl={anchorEl}
        handleClose={handleClose}
        open={open}
        id={id}
      />
    </Box>
  );
};

export default UserFilterMenuButton;
